"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from "react";
import UnlockButton from "@/app/[lng]/checkout/[busrequestId]/_components/ unlockbutton";
import { BusRequest, RequestCompanyType } from "@/types/busrequest";
import { CompanyInfoType } from "@/types/company";
import { OutboundLink } from "@/components/OutboundLink";
import { useLocaleContext, useTranslation } from "@/app/i18n/client";
import { getIconForCompanyInfoType, getIconForRequestCompanyType } from "@/utils/Utils";
import { TFunction } from "i18next";
interface Props {
  request: BusRequest;
}
function ContactItem(t0) {
  const $ = _c(10);
  const {
    icon,
    type,
    value
  } = t0;
  if (!value || "") {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <></>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  const href = type === "email" ? `mailto:${value}` : `tel:${value}`;
  let t1;
  if ($[1] !== icon) {
    t1 = <div>{icon}</div>;
    $[1] = icon;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = `company-${type}`;
  let t3;
  if ($[3] !== href || $[4] !== t2 || $[5] !== value) {
    t3 = <OutboundLink data-testid={t2} className="text-secondary" eventLabel={href} to={href} target="_blank">{value}</OutboundLink>;
    $[3] = href;
    $[4] = t2;
    $[5] = value;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t1 || $[8] !== t3) {
    t4 = <div className="flex items-start justify-between gap-2 pt-1">{t1}{t3}</div>;
    $[7] = t1;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}
export default function BuspartnerCompanyContact({
  request
}: Props) {
  const {
    t
  } = useTranslation(["common", "busrequests"]);
  const lng = useLocaleContext();
  const contactItems = useMemo(() => request ? getContactItems(request, t) : [], [request]);
  console.log("Busrequest", request);
  return contactItems.length > 0 ? <div className="flex flex-col gap-1 divide-x-0 divide-y divide-dashed divide-secondary">
      {contactItems}
      {!request?.email && <div className="flex justify-end pt-4">
          <UnlockButton busrequestId={request.id} />
        </div>}
    </div> : <div className="card-contact-title">{t("HOME.MODALS.CONTACT.EMPTY")}</div>;
}
function getWebsiteLink(website?: string): string {
  if (!website) return "";
  const httpSuffix = website?.startsWith("http://", 0) || website?.startsWith("https://", 0) || false;
  return httpSuffix ? website : `https://${website}`;
}
function getContactItems(request: BusRequest, t: TFunction<"common">): React.ReactElement[] {
  let contactItems: React.ReactElement[] = [];
  contactItems = contactItems.concat(<ContactItem key={"name"} icon={getIconForRequestCompanyType(request.companyType, !!request.company)} type={"name"} value={request.company || request.email ? request.companyName : t(`PROVIDER.COMPANYTYPE.${request.companyType}.TEXT`)} />);
  contactItems = !!request.telephone ? contactItems.concat(<ContactItem key={"telephone"} icon={getIconForCompanyInfoType("telephone")} type={"telephone"} value={request.telephone} />) : contactItems;
  contactItems = !!request.cellphone ? contactItems.concat(<ContactItem key={"cellphone"} icon={getIconForCompanyInfoType("cellphone")} type={"cellphone"} value={request.cellphone} />) : contactItems;
  contactItems = !!request.fax ? contactItems.concat(<ContactItem key={"fax"} icon={getIconForCompanyInfoType("fax")} type={"fax"} value={request.fax} />) : contactItems;
  contactItems = !!request.email ? contactItems.concat(<ContactItem key={"email"} icon={getIconForCompanyInfoType("email")} type={"email"} value={request.email} />) : contactItems;
  return contactItems;
}